<template>
    <Icon class="on-off-switch" :width="29" :height="18" :bgPosition="position" @iconClick="iconClick" />
</template>

<script>
import Icon from "../icons/Icon";

export default {
    name: "OnOffSwitch",
    props: ["state"], // on off
    components: {
        Icon
    },
    data() {
        return {
            status: this.state || "off",
            position: this.state == "on" ? "-88px -62px" : "-88px -43px"
        };
    },
    watch: {
        state() {
            this.status = this.state;
            this.position = this.getPosition();
        }
    },
    methods: {
        iconClick() {
            this.status = this.status == "on" ? "off" : "on";
            this.position = this.getPosition();
            this.$emit("switch", this.status);
        },
        getPosition() {
            return this.status == "on" ? "-88px -62px" : "-88px -43px";
        }
    }
};
</script>

<style lang="less" scoped>
.on-off-switch {
}
</style>
